
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ModalUserData from '@/components/templates/manage/ModalUserData.vue'
import { UserBranchesApi } from '@/api/methods/manage/UserBranchesApi'
import { UsersApi } from '@/api/methods/UsersApi'
import StringUtils from '@/utils/StringUtils'

/**
 * 先生情報編集モーダル
 */
@Component({
  components: {
    ModalUserData,
  },
})
export default class ModalEditTeacher extends Vue {
  /** ユーザ情報モーダルのフォーマット */
  @Ref()
  modalUserData!: ModalUserData

  /** 先生更新後の処理 */
  @Prop()
  private afterUpdateTeacher!: () => Promise<void>

  /** 更新対象のユーザID */
  private userId = 0

  /**
   * 送信ボタンのdisabled制御
   *
   * @param nickname ニックネーム
   * @param _password パスワード
   * @param _confirm 確認用パスワード
   * @param _selectedValue 教室選択
   * @returns 未入力があった場合はtrue
   */
  private submitDisabled(nickname: string, _password: string, _confirm: string, _selectedValue: string): boolean {
    // ニックネームが未入力の場合true
    if (StringUtils.isBlank(nickname)) {
      return true
    }

    return false
  }

  /**
   * 確認ボタン押下時の処理
   */
  private async submit(): Promise<void> {
    this.$loading.start()

    let errorMessage = null

    // 対象ユーザIDのバリデーションチェック
    errorMessage = this.validUserId()
    if (errorMessage) {
      alert(errorMessage)
      this.$loading.complete()
      return
    }

    // 先生情報更新
    await UserBranchesApi.updateTeacher(this.userId, this.modalUserData.nickname)

    // 先生更新後の処理
    //   メソッド内で先生一覧の再取得を行う
    await this.afterUpdateTeacher()

    // 登録APIを追加
    this.$loading.complete()

    // モーダルを閉じる
    this.hide()
  }

  /**
   * 対象ユーザIDのバリデーションチェック
   *
   * @returns 値が無効な場合エラーメッセージを返す
   */
  private validUserId(): string | null {
    // IDが初期値0のままの場合
    if (!this.userId) {
      return 'ユーザIDが無効です'
    }

    return null
  }

  /**
   * モーダルを開く
   *
   * @param userId ユーザID
   */
  public async show(userId: number): Promise<void> {
    // ユーザID設定
    this.userId = userId

    this.$loading.start()

    // ユーザ情報取得
    const user = await UsersApi.getUser(userId)

    this.$loading.complete()

    // モーダルを開く
    this.modalUserData.show(user.nickname)
  }

  /**
   * モーダルを閉じる
   */
  private hide(): void {
    this.modalUserData.hide()
  }
}
